export default __webpack_public_path__ + "static/media/google-adsense.89c2211d.svg";